import { render, staticRenderFns } from "./MobileUpdate copy.vue?vue&type=template&id=11d0036e&scoped=true&"
import script from "./MobileUpdate copy.vue?vue&type=script&lang=js&"
export * from "./MobileUpdate copy.vue?vue&type=script&lang=js&"
import style0 from "./MobileUpdate copy.vue?vue&type=style&index=0&id=11d0036e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d0036e",
  null
  
)

export default component.exports